/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { orderTypeNameSchema } from './orderTypeNameSchema'
import { orgTypeNameSchema } from './orgTypeNameSchema'

export const paymentProcessResultV4Schema = z
  .object({
    settled: z
      .boolean()
      .default(false)
      .describe(
        "True — a payment that is not settled answers 400 with the bank's message instead."
      ),
    orderType: orderTypeNameSchema.describe('What the order paid for.'),
    switchToOrgId: z
      .string()
      .default('')
      .describe(
        'Coded id of the organization the order belongs to — for a registration, the one it created.'
      )
      .meta({ examples: ['kJ8v2Qm7xR1a'] }),
    switchToOrgType: orgTypeNameSchema.describe("The organization's type."),
  })
  .describe('A settled order. The client switches into `switchToOrgId` with `auth/switch`.')
